module.exports = __webpack_public_path__ + "static/img/30-北京大学附属中学1.7bd2a40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/30-北京大学附属中学1.png
// module id = kWew
// module chunks = 0